module.exports = __webpack_public_path__ + "assets/img/favicons/ms-icon-70x70.png";